import {client} from '../helpers/api';

// todo: subjects list
export async function getPackages() {
  const response = await client.get('/api/packages');

  if (response.data?.status) {
    return (
      response.data?.data.map(
        ({
          package_id: id,
          _grade_id: gradeId,
          package_type: type,
          package_name: name,
          package_image: image,
          package_price: price,
          description,
          ios_product_id,
          ios_package_price,
        }) => ({
          id,
          gradeId,
          type,
          name,
          image,
          price,
          description,
          ios_product_id,
          ios_package_price,
        }),
      ) || []
    );
  }
  throw response;
}

// {
//   "package_id": "95040bcb-3020-48b5-a332-a008609772a0",
//   "_grade_id": "3c8d3bd8-9cf5-488e-a884-f51dc5afe576",
//   "package_type": "Individual",
//   "package_name": null,
//   "package_image": "default_package.png",
//   "package_price": 40,
//   "description": "PER SUBJECT",
//   "date_created": "2021-01-14 11:45:43",
//   "date_modified": "2021-01-14 11:45:43",
//   "status": "active",
//   "is_deleted": 0
// }

// {
//   "package_id": "40db33d5-5760-4d17-b26a-7a46feb4dab5",
//   "_grade_id": "bab77fd6-ea8c-402b-b777-1f1d297c9c7e",
//   "package_type": "Package",
//   "package_name": null,
//   "package_image": "default_package.png",
//   "package_price": 120,
//   "description": "ALL SUBJECTS",
//   "date_created": "2021-01-14 11:45:43",
//   "date_modified": "2021-01-14 11:45:43",
//   "status": "active",
//   "is_deleted": 0
// }
